import { useState } from 'react';
import { Banner } from '@cad-arc';
import { useIsFederatedSearchEnabledButConfirmedUnavailable } from './federated-search-remote-state-context';

export function FederatedSearchUnavailableBanner(): React.ReactElement | null {
    const isFederatedSearchEnabledButConfirmedUnavailable = useIsFederatedSearchEnabledButConfirmedUnavailable();
    const [isBannerOpen, setIsBannerOpen] = useState(true);

    if (!isFederatedSearchEnabledButConfirmedUnavailable || !isBannerOpen) {
        return null;
    }

    return (
        <Banner
            status="attention"
            title="Universal Search Unavailable"
            description="Universal Search is currently unavailable. Try reloading the app. If the issue persists, contact Mark43."
            style={{ width: '100%', zIndex: 1 }}
            onClose={() => setIsBannerOpen(false)}
        />
    );
}
